import { isPopulated } from "./Utilities";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PersonIcon from '@mui/icons-material/Person';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

const contentHost = "http://webblob.assingaround.com"
const API_ENDPOINT = "api.speedypik.com"
//const API_ENDPOINT = "localhost:5000"

// Return the index -> Update these later
function getPlatformIndex() {
    const domainName = window.location.hostname;
    if (domainName.toLowerCase().includes("gj")) return "gj";
    if (domainName.toLowerCase().includes("rvo")) return "rvo";
    if (domainName.toLowerCase().includes("rampex")) return "rampex";
    else return "rampex";
}

const defaultStyle = { width: 1050, height: 300 }
function fetchPlatformData(dataType) {
    const platforms = {
        gj: {
            name: "GJ Drivelines",
            siteImages: {
                logo: `${contentHost}/gjdrivelines.png`,
                main: `${contentHost}/gjmain.jpg`
            },
            staticPage: false,
            navMenu: [{
                label: 'Contact Us',
                toolbarType: "text",
                clickTarget: "contactus"
            }, {
                label: 'Gallery',
                toolbarType: "text",
                clickTarget: 'gallery'
            },
            {
                label: 'Services',
                toolbarType: "text",
                clickTarget: "services"
            },
            {
                label: 'Order',
                toolbarType: "text",
                clickTarget: "customorder"
            },
            {
                label: 'Store',
                toolbarType: "text",
                clickTarget: "store"
            }, {
                icon: (<ShoppingCartIcon />),
                label: "Cart",
                toolbarType: "icon",
                clickTarget: "store/cart",
                alwaysAppear: true
            }, {
                icon: (<PersonIcon />),
                label: "Account",
                toolbarType: "icon",
                clickTarget: "store/account",
                alwaysAppear: true
            }, {
                icon: (<AdminPanelSettingsIcon />),
                label: "Admin",
                toolbarType: "icon",
                clickTarget: "admin/main",
                alwaysAppear: true
            }],
            customerQuotes: ["Test google review multiline quote", "test google review 2"],
            contactUs: [{
                "branch_name": "Head Office - Keysborough",
                "branch_address": "2/189 Cheltenham Rd, Keysborough VIC 3173",
                "branch_map_link": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3144.3398199056037!2d145.18691947688455!3d-37.99253344427781!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad6139b26aa75a1%3A0xc3212155502b1e00!2sGJ%20Drivelines!5e0!3m2!1sen!2sau!4v1697139618689!5m2!1sen!2sau",
                "email": "gjdrivelines@live.com.au",
                "phone_number": "(03) 9706 3166",
                "trading_hours:": ["Monday to Thursday: 8am-5pm", "Friday: 8am-4pm", "Saturday & Sunday: Closed"],
                "social_links": [{ "name": "Facebook", "icon": "facebook_icon.png", "link": "https://www.facebook.com/tailshafts/" }, { "name": "Instagram", "icon": "instagram_icon.png", "link": "https://www.instagram.com/gjdrivelines/" }],
            },
            {
                "branch_name": "Somerton",
                "branch_address": "794 Cooper St, Somerton VIC 3062",
                "branch_map_link": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3159.168798002235!2d144.96730137687103!3d-37.64523542442682!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad64f167fa2584d%3A0x4a8991be8b3e1bee!2sGJ%20Drivelines!5e0!3m2!1sen!2sau!4v1697143311800!5m2!1sen!2sau",
                "email": "sales@gjdrivelines.com.au",
                "phone_number": "(03) 9305 7261",
                "trading_hours:": ["Monday to Thursday: 8am - 5pm", "Friday: 8am - 4pm", "Saturday & Sunday: Closed"],
                "social_links": [{ "name": "Facebook", "icon": "facebook_icon.png", "link": "https://www.facebook.com/gjdrivelinessomerton" }],
            }],
            services: {
                enquiryEmail: "tavrinn@hotmail.com",
                category: [{
                    name: "Performance",
                    items: [{
                        name: "Performance Tailshafts",
                        image: `${contentHost}/services/gj/performance_tailshafts.jpg`,
                        description: "(add extra description text here)"
                    },
                    {
                        name: "Performance Parts",
                        image: `${contentHost}/services/gj/tailshaft_reconditioning.jpg`,
                        description: "(add extra description text here)"
                    }]
                },
                {
                    name: "Reconditioning & Changeovers",
                    items: [{
                        name: "General Reconditioning",
                        image: `${contentHost}/services/gj/tailshaft_reconditioning.jpg`,
                        description: "(add extra description text here)"
                    },
                    {
                        name: "Changeovers",
                        image: `${contentHost}/services/gj/tailshaft_reconditioning.jpg`,
                        description: "(add extra description text here)"
                    }]
                },
                {
                    name: "Driveline Parts",
                    items: [{
                        name: "Manufacturing Services",
                        image: `${contentHost}/services/gj/tailshaft_reconditioning.jpg`,
                        description: "(add extra description text here)"
                    }]
                },
                {
                    name: "Heavy / Industrial",
                    items: [{
                        name: "Truck Shafts",
                        image: `${contentHost}/services/gj/tailshaft_reconditioning.jpg`,
                        description: "(add extra description text here)"
                    }]
                },
                {
                    name: "Transport",
                    items: [{
                        name: "Truck Shafts",
                        image: `${contentHost}/services/gj/tailshaft_reconditioning.jpg`,
                        description: "(add extra description text here)"
                    }]
                }]
            },
            shop: {
                enquiryEmail: "tavrinn@hotmail.com",
                category: [{
                    name: "Fuel Systems",
                    items: [{
                        name: "Surge tank No.1",
                        image: contentHost + "/shop/rampex/fuel_tank.jpg",
                        price: "$2500",
                        description: "Fuel tank - Custom designed to suit your needs. Prices start at $2500. Contact us to get started"
                    },
                    {
                        name: "Surge tank No.2",
                        image: contentHost + "/shop/rampex/fuel_tank.jpg",
                        price: "$2500",
                        description: "Fuel tank - Custom designed to suit your needs. Prices start at $2500. Contact us to get started"
                    }]
                },
                {
                    name: "Water Tanks",
                    items: [{
                        name: "Water tank No.1",
                        image: contentHost + "/shop/rampex/fuel_tank.jpg",
                        price: "$2500",
                        description: "Fuel tank - Custom designed to suit your needs. Prices start at $2500. Contact us to get started"
                    },
                    {
                        name: "Water tank No.2",
                        image: contentHost + "/shop/rampex/fuel_tank.jpg",
                        price: "$2500",
                        description: "Fuel tank - Custom designed to suit your needs. Prices start at $2500. Contact us to get started"
                    }]
                }]
            },


            orderForm: [
                {
                    name: 'Before you order',
                    paragraphs: [{
                        name: "",
                        type: "cards",
                        items: [
                            { name: "Tailshaft 101", type: "card", content: "How to measure for a custom Tailshaft", link: "/customtailshaftinfo" }
                        ]
                    }],
                    optional: false
                },
                {
                    name: 'Specs',
                    paragraphs: [{
                        name: "Chasis / Engine",
                        type: "fields",
                        items: [
                            { id: "chassisEngine_car", name: "Car / Chassis", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "chassisEngine_engine", name: "Engine", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "chassisEngine_induction", name: "Induction", type: "dropDown", items: ["Naturally Aspirated", "Supercharged", "Turbocharged", "Nitrous"], helperText: "must be selected", isError: (val) => isPopulated(val) }]
                    },
                    // Transmission Configuration
                    {
                        name: "Transmission",
                        type: "fields",
                        items: [
                            { id: "trans_name", name: "Make / Model / Brand", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_tbrake", name: "Transbrake", type: "dropDown", items: ["YES", "NO"], helperText: "must be selected", isError: (val) => isPopulated(val) },
                            { id: "trans_outputStyle", name: "Output Style", type: "dropDown", items: ["Slip Yoke", "3 Bolt Flange", "4 Bolt Flange", "6 Bolt Flange", "8 Bolt Flange", "Fixed Yoke"], trackState: true, helperText: "must be selected", isError: (val) => isPopulated(val) }]
                    },
                    {
                        name: "Transmission Slip Yoke",
                        type: "fields",
                        style: { display: "block" },
                        visibleIf: (state) => state.trans_outputStyle === "Slip Yoke",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/transmission-slip-yoke.jpg", style: defaultStyle }
                        ]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.trans_outputStyle === "Slip Yoke",
                        items: [
                            { id: "trans_slipYoke_n", name: "N - Spline Count", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_slipYoke_j", name: "J - Shaft Diameter", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_slipYoke_b", name: "B - Spline Extension", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) }
                        ]
                    },
                    {
                        name: "3 Bolt Flange",
                        type: "fields",
                        visibleIf: (state) => state.trans_outputStyle === "3 Bolt Flange",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/transmission-3-bolt-flange.jpg", style: defaultStyle }
                        ]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.trans_outputStyle === "3 Bolt Flange",
                        items: [
                            { id: "trans_threeBoltFlange_m", name: "M", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_threeBoltFlange_f", name: "F", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_threeBoltFlange_b", name: "B - Spigot Diameter", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_threeBoltFlange_spigotSex", name: "Spigot Sex", type: "dropDown", items: ["MALE", "FEMALE"], helperText: "must be selected", isError: (val) => isPopulated(val) }
                        ]
                    },
                    {
                        name: "4 Bolt Flange",
                        type: "fields",
                        visibleIf: (state) => state.trans_outputStyle === "4 Bolt Flange",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/transmission-4-bolt-flange.jpg", style: defaultStyle }
                        ]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.trans_outputStyle === "4 Bolt Flange",
                        items: [
                            { id: "trans_fourBoltFlange_j", name: "J - Measurement [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_fourBoltFlange_k", name: "K - Measurement [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_fourBoltFlange_h", name: "K - Bolt hole diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_fourBoltFlange_d", name: "D - Spigot Diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_fourBoltFlange_spigotSex", name: "Spigot Sex", type: "dropDown", items: ["MALE", "FEMALE"], helperText: "must be selected", isError: (val) => isPopulated(val) }
                        ]
                    },
                    {
                        name: "6 Bolt Flange",
                        type: "fields",
                        visibleIf: (state) => state.trans_outputStyle === "6 Bolt Flange",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/transmission-6-bolt-flange.jpg", style: defaultStyle }
                        ]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.trans_outputStyle === "6 Bolt Flange",
                        items: [
                            { id: "trans_sixBoltFlange_k", name: "K - PCD", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_sixBoltFlange_h", name: "H - Bolt Hole Diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_sixBoltFlange_d", name: "D - Spigot Diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_sixBoltFlange_spigotSex", name: "Spigot Sex", type: "dropDown", items: ["MALE", "FEMALE"], helperText: "must be selected", isError: (val) => isPopulated(val) }
                        ]
                    },
                    {
                        name: "8 Bolt Flange",
                        type: "fields",
                        visibleIf: (state) => state.trans_outputStyle === "8 Bolt Flange",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/transmission-8-bolt-flange.jpg", style: defaultStyle }
                        ]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.trans_outputStyle === "8 Bolt Flange",
                        items: [
                            { id: "trans_eightBoltFlange_k", name: "K - PCD", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_eightBoltFlange_h", name: "H - Bolt Hole Diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_eightBoltFlange_d", name: "D - Spigot Diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_eightBoltFlange_spigotSex", name: "Spigot Sex", type: "dropDown", items: ["MALE", "FEMALE"], helperText: "must be selected", isError: (val) => isPopulated(val) }
                        ]
                    },
                    {
                        name: "Fixed Yoke",
                        type: "fields",
                        visibleIf: (state) => state.trans_outputStyle === "Fixed Yoke",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/transmission-fixed-yoke.jpg", style: defaultStyle }
                        ]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.trans_outputStyle === "Fixed Yoke",
                        items: [
                            { id: "trans_fixedYoke_c", name: "C - Cap Diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "trans_fixedYoke_e_g_selection", name: "Measurement Type", type: "dropDown", items: ["E", "G"], helperText: "must be selected", isError: (val) => isPopulated(val) },
                            { id: "trans_fixedYoke_e_g_measurement", name: "E or G - Length [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                        ]
                    },
                    // Differential Configuration
                    {
                        name: "Differential - Rear",
                        type: "fields",
                        items: [
                            { id: "diff_name", name: "Make/model/brand", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_input_style", name: "Input Style", type: "dropDown", items: ["Pinion Yoke", "3 Bolt Flange", "4 Bolt Flange", "6 Bolt Flange", "8 Bolt Flange"], trackState: true, helperText: "must be selected", isError: (val) => isPopulated(val) }]
                    },
                    {
                        name: "Pinion Yoke",
                        type: "fields",
                        visibleIf: (state) => state.diff_input_style === "Pinion Yoke",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/differential-pinion-yoke.jpg", style: defaultStyle }
                        ]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.diff_input_style === "Pinion Yoke",
                        items: [
                            { id: "diff_pinionYoke_c", name: "C - Cap Diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_pinionYoke_e_g_selection", name: "Measurement Type", type: "dropDown", items: ["E", "G"], helperText: "must be selected", isError: (val) => isPopulated(val) },
                            { id: "diff_pinionYoke_e_g_measurement", name: "E or G - Length [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                        ]
                    },
                    {
                        name: "3 Bolt Flange",
                        type: "fields",
                        visibleIf: (state) => state.diff_input_style === "3 Bolt Flange",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/differential-3-bolt-flange.jpg", style: defaultStyle }
                        ]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.diff_input_style === "3 Bolt Flange",
                        items: [
                            { id: "diff_threeBoltFlange_m", name: "M", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_threeBoltFlange_f", name: "F", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_threeBoltFlange_b", name: "B - Spigot Diameter", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_threeBoltFlange_spigotSex", name: "Spigot Sex", type: "dropDown", items: ["MALE", "FEMALE"], helperText: "must be selected", isError: (val) => isPopulated(val) }
                        ]
                    },
                    {
                        name: "4 Bolt Flange",
                        type: "fields",
                        visibleIf: (state) => state.diff_input_style === "4 Bolt Flange",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/differential-4-bolt-flange.jpg", style: defaultStyle }
                        ]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.diff_input_style === "4 Bolt Flange",
                        items: [
                            { id: "diff_fourBoltFlange_j", name: "J - Measurement [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_fourBoltFlange_k", name: "K - Measurement [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_fourBoltFlange_h", name: "K - Bolt hole diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_fourBoltFlange_d", name: "D - Spigot Diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_fourBoltFlange_spigotSex", name: "Spigot Sex", type: "dropDown", items: ["MALE", "FEMALE"], helperText: "must be selected", isError: (val) => isPopulated(val) }
                        ]
                    },
                    {
                        name: "6 Bolt Flange",
                        type: "fields",
                        visibleIf: (state) => state.diff_input_style === "6 Bolt Flange",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/differential-6-bolt-flange.jpg", style: defaultStyle }
                        ]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.diff_input_style === "6 Bolt Flange",
                        items: [
                            { id: "diff_sixBoltFlange_k", name: "K - PCD", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_sixBoltFlange_h", name: "H - Bolt Hole Diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_sixBoltFlange_d", name: "D - Spigot Diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_sixBoltFlange_spigotSex", name: "Spigot Sex", type: "dropDown", items: ["MALE", "FEMALE"], helperText: "must be selected", isError: (val) => isPopulated(val) }
                        ]
                    },
                    {
                        name: "8 Bolt Flange",
                        type: "fields",
                        visibleIf: (state) => state.diff_input_style === "8 Bolt Flange",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/differential-8-bolt-flange.jpg", style: defaultStyle }
                        ]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.diff_input_style === "8 Bolt Flange",
                        items: [
                            { id: "diff_eightBoltFlange_k", name: "K - PCD", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_eightBoltFlange_h", name: "H - Bolt Hole Diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_eightBoltFlange_d", name: "D - Spigot Diameter [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "diff_eightBoltFlange_spigotSex", name: "Spigot Sex", type: "dropDown", items: ["MALE", "FEMALE"], helperText: "must be selected", isError: (val) => isPopulated(val) }
                        ]
                    },
                    // Tailshaft Configuration
                    {
                        name: "Tailshaft",
                        type: "fields",
                        items: [
                            { id: "tailshaft_style", name: "Style", type: "dropDown", items: ["1 Piece", "2 Piece", "3 Piece"], trackState: true, helperText: "must be selected", isError: (val) => isPopulated(val) },
                            { id: "tailshaft_size_restrictions", name: "Size Restrictions", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "tailshaft_maxDia", name: "Max Diameter", type: "dropDown", items: ["<2.5\"", "2.5\"", "2.75\"", "3.0\"", "3.25\"", "3.50\"", "3.80\"", "4.00\"", "4.50\"", "5.00\"", "5\"+"], helperText: "must be selected", isError: (val) => isPopulated(val) }
                        ]
                    },
                    {
                        name: "Measurements - 1 piece",
                        type: "fields",
                        visibleIf: (state) => state.tailshaft_style === "1 Piece",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/tailshaft-1-piece.jpg", style: { width: 1400, height: 300 } }
                        ],
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.tailshaft_style === "1 Piece",
                        items: [
                            { id: "tailshaft_1_piece_a", name: "A - Overall Length [Transmission to Differential] [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) }
                        ],
                    },
                    {
                        name: "Measurements - 2 piece",
                        type: "fields",
                        visibleIf: (state) => state.tailshaft_style === "2 Piece",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/tailshaft-2-piece.jpg", style: { width: 1400, height: 300 } }]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.tailshaft_style === "2 Piece",
                        items: [
                            { id: "tailshaft_2_piece_a", name: "A - Overall Length [Transmission to Differential] [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "tailshaft_2_piece_x1", name: "X1 - Transmission to Center Bearing [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "tailshaft_2_piece_x2", name: "X2 - Center Bearing to Differential [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "tailshaft_2_piece_w1", name: "W1 - Center Bearing Bracket Bolt hole Spacing [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) }]
                    },
                    {
                        name: "Measurements - 3 piece",
                        type: "fields",
                        visibleIf: (state) => state.tailshaft_style === "3 Piece",
                        items: [
                            { name: "ImageName", type: "image", imgsrc: "/custom_order/gj/tailshaft-3-piece.jpg", style: { width: 1400, height: 300 } }]
                    },
                    {
                        type: "fields",
                        visibleIf: (state) => state.tailshaft_style === "3 Piece",
                        items: [
                            { id: "tailshaft_3_piece_a", name: "A - Overall Length [Transmission to Differential] [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "tailshaft_3_piece_x1", name: "X1 - Transmission to Center Bearing [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "tailshaft_3_piece_x2", name: "X2 - Center Bearing to Center Bearing [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "tailshaft_2_piece_x3", name: "X3 - Center Bearing to Differential [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "tailshaft_3_piece_w1", name: "W1 - Center Bearing Bracket Bolt hole Spacing [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "tailshaft_3_piece_w2", name: "W2 - Center Bearing Bracket Bolt hole Spacing [mm]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) }]
                    },
                    {
                        name: "Limits",
                        type: "fields",
                        items: [
                            { id: "limits_targetHP", name: "Target HP", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "limits_targetTorque", name: "Target Torque [NM]", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "limits_maxRPM", name: "Max RPM", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) }]
                    },
                    {
                        name: "Other",
                        type: "fields",
                        items: [
                            { id: "other_usage", name: "What is the car being used for? (Street, Race, etc.)", type: "textInput", helperText: "must be specified", isError: (val) => isPopulated(val) },
                            { id: "other_material_preference", name: "Material preference", type: "dropDown", items: ["Steel", "CrMo", "Aluminimum", "Carbon Fiber", "Best Recommendation"], helperText: "must be selected", isError: (val) => isPopulated(val) },
                            { id: "other_who_will_install", name: "Who will install?", type: "dropDown", items: ["Myself", "A Workshop"], helperText: "must be selected", isError: (val) => isPopulated(val) }]
                    },
                    ],
                    optional: false
                }
            ],
            about: {
                quotes: ['GJ has been a valuable partner', 'GJ ramped us', 'Something else...'],
                achievements: [{
                    title: "Unrivalled Excellence",
                    description: "GJ is a leading manufacturer of performance tailshafts",
                    image: `${contentHost}/services/gj/performance_tailshafts.jpg`
                },
                {
                    title: "Our Clients",
                    description: "We work with a wide array of clients and build all sorts of tailshafts",
                    image: `${contentHost}/services/gj/tailshaft_reconditioning.jpg`
                },
                {
                    title: "Spare Parts",
                    description: "We have a wide range of center bearings in stock",
                    image: `${contentHost}/services/gj/centre_bearings.jpg`
                }]
            },
            imageGallery: [{ imgPath: `${contentHost}/image_gallery/gj_drivelines/GJ4X4.jpg`, imgDescription: "GJ 4x4 Jets" },
            { imgPath: `${contentHost}/image_gallery/gj_drivelines/GJ-Shirt-Art.jpg`, imgDescription: "GJ Shirts" },
            { imgPath: `${contentHost}/image_gallery/gj_drivelines/IMG_5501-2.jpg`, imgDescription: "GJ Misc" },
            { imgPath: `${contentHost}/image_gallery/gj_drivelines/IMG_7277-1.jpg`, imgDescription: "GJ Misc" },
            ],
            mainHeader: {
                title: "Driveline and tailshaft specialist",
                googleReviewsLink: "https://www.google.com/search?q=gj+drivelines&oq=GJ+&gs_lcrp=EgZjaHJvbWUqCQgAECMYJxiKBTIJCAAQIxgnGIoFMgYIARBFGDkyBggCECMYJzIGCAMQRRg8MgYIBBBFGDwyBggFEEUYPDIGCAYQRRg8MgYIBxBFGDzSAQgxMTEyajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#",
                storeLocations: [{
                    name: "Keysborough",
                    socials: [{
                        name: "Phone",
                        link: "tel:0397063166",
                    },
                    {
                        name: "Facebook",
                        link: "https://www.facebook.com/tailshafts/",
                    },
                    {
                        name: "Instagram",
                        link: "https://www.instagram.com/gjdrivelines/",
                    }]
                },
                {
                    name: "Somerton",
                    socials: [{
                        name: "Phone",
                        link: "tel:0393057261"
                    }, {
                        name: "Facebook",
                        link: "https://www.facebook.com/gjdrivelinessomerton",
                    }]
                }
                ]
            },
            theme: {
                primary: {
                    main: "rgb(241, 120, 3)",
                    background: "rgba(134, 42, 61, 0.4)",
                    backgroundLight: "rgba(134, 42, 61, 0.2)",
                    backgroundDark: "rgba(134, 42, 61, 0.8)"
                },
                secondary: {
                    main: "rgb(241, 120, 3)",
                    backgroundDark: "rgba(29, 48, 80, 0.8)",
                    background: "rgba(29, 48, 80, 0.2)",
                    backgroundLight: "rgba(29, 48, 80, 0.1)",
                }
            }
        },
        rvo: {
            name: "RVO Automatics",
            siteImages: {
                logo: `${contentHost}/rvo_logo.png`,
                main: `${contentHost}/rvo_main.jpg`
            },
            staticPage: true,
            navMenu: [{
                label: 'Contact Us',
                toolbarType: "text",
                clickTarget: "contactus"
            }, {
                label: 'Gallery',
                toolbarType: "text",
                clickTarget: 'gallery'
            },
            {
                label: 'Services',
                toolbarType: "text",
                clickTarget: "services"
            },
            {
                label: 'Shop',
                toolbarType: "text",
                clickTarget: "shop"
            }],
            contactUs: [{
                "branch_name": "Head Office - Dandenong South",
                "branch_address": "4 Egan Rd, Dandenong South VIC 3175",
                "branch_map_link": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3144.2152509702332!2d145.19133467688462!3d-37.99543944444463!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad6139066b40d9f%3A0x31282981dbe500ed!2sRVO%20Performance%20%26%20Automatics!5e0!3m2!1sen!2sau!4v1697160273249!5m2!1sen!2sau",
                "email": "rvoautomatics@yahoo.com.au",
                "phone_number": "(03) 9794 5004",
                "trading_hours:": ["Monday to Friday: 8:30am - 5:30pm", "Saturday & Sunday: Closed"],
                "social_links": [{ "name": "Facebook", "icon": "facebook_icon.png", "link": "https://www.facebook.com/RVOAUTOMATICS/" }, { "name": "TikTok", "icon": "tiktok_icon.png", "link": "https://www.tiktok.com/@rvoautomatics" }],
            }],
            services: {
                enquiryEmail: "tavrinn@hotmail.com",
                category: [{
                    name: "Performance Transmissions",
                    items: [{
                        name: "Performance Upgrades",
                        image: `${contentHost}/image_gallery/rvo/1.jpg`,
                        description: "(add extra description text here)"
                    },
                    {
                        name: "Performance Rebuilds",
                        image: `${contentHost}/image_gallery/rvo/2.jpg`,
                        description: "(add extra description text here)"
                    }]
                },
                {
                    name: "Transmission Rebuilds",
                    items: [{
                        name: "General Rebuilds",
                        image: `${contentHost}/image_gallery/rvo/19.jpg`,
                        description: "(add extra description text here)"
                    },
                    {
                        name: "Performance Rebuilds",
                        image: `${contentHost}/image_gallery/rvo/7.jpg`,
                        description: "(add extra description text here)"
                    }]
                },
                {
                    name: "Transmission Service",
                    items: [{
                        name: "In Car Tranny Services",
                        image: `${contentHost}/image_gallery/rvo/12.jpg`,
                        description: "(add extra description text here)"
                    }]
                },
                {
                    name: "Parts and Service",
                    items: [{
                        name: "In Car Tranny Services",
                        image: `${contentHost}/image_gallery/rvo/17.jpg`,
                        description: "(add extra description text here)"
                    }]
                }]
            },
            shop: {
                enquiryEmail: "tavrinn@hotmail.com",
                category: [{
                    name: "Holden - 4 Speed",
                    items: [{
                        name: "4L60E - Stage 1",
                        image: `${contentHost}/shop/rvo/4l60e.jpg`,
                        price: "$1000",
                        description: "4L60E Stage 1 description text"
                    },
                    {
                        name: "4L60E - Stage 2",
                        image: `${contentHost}/shop/rvo/4l60e.jpg`,
                        price: "$2500",
                        description: "4L60E Stage 2 description text"
                    },
                    {
                        name: "4L60E - Stage 3",
                        image: `${contentHost}/shop/rvo/4l60e.jpg`,
                        price: "$3500",
                        description: "4L60E Stage 3 description text"
                    },
                    {
                        name: "4L60E - Stage 4",
                        image: `${contentHost}/shop/rvo/4l60e.jpg`,
                        price: "$6000",
                        description: "4L60E Stage 4 description text"
                    }]
                },
                {
                    name: "Holden - 5 Speed",
                    items: [{
                        name: "5L40E - Stage 1",
                        image: `${contentHost}/shop/rvo/4l60e.jpg`,
                        price: "$1000",
                        description: "5L40E Stage 1 description text"
                    },
                    {
                        name: "5L40E - Stage 2",
                        image: `${contentHost}/shop/rvo/4l60e.jpg`,
                        price: "$2500",
                        description: "5L40E Stage 2 description text"
                    },
                    {
                        name: "5L40E - Stage 2",
                        image: `${contentHost}/shop/rvo/4l60e.jpg`,
                        price: "$2500",
                        description: "5L40E Stage 2 description text"
                    },
                    {
                        name: "5L40E - Stage 2",
                        image: `${contentHost}/shop/rvo/4l60e.jpg`,
                        price: "$2500",
                        description: "5L40E Stage 2 description text"
                    }]
                },
                {
                    name: "Holden - 6 Speed",
                    items: [{
                        name: "6L80E - Stage 1",
                        image: `${contentHost}/shop/rvo/4l60e.jpg`,
                        price: "$1000",
                        description: "6L80E Stage 1 description text"
                    },
                    {
                        name: "6L80E - Stage 1",
                        image: `${contentHost}/shop/rvo/4l60e.jpg`,
                        price: "$1000",
                        description: "6L80E Stage 1 description text"
                    },
                    {
                        name: "6L80E - Stage 1",
                        image: `${contentHost}/shop/rvo/4l60e.jpg`,
                        price: "$1000",
                        description: "6L80E Stage 1 description text"
                    },
                    {
                        name: "6L80E - Stage 1",
                        image: `${contentHost}/shop/rvo/4l60e.jpg`,
                        price: "$1000",
                        description: "6L80E Stage 1 description text"
                    }]
                }]
            },
            orderForm: [
                {
                    name: 'Before your order',
                    paragraphs: [{
                        name: "",
                        type: "cards",
                        items: [
                            { name: "Transmission 101", type: "card", content: "101 brief description on how to order your RVO transmission" }
                        ]
                    }],
                    optional: false
                },
                {
                    name: 'Your',
                    paragraphs: [{
                        name: "Name",
                        type: "fields",
                        items: [
                            { name: "First Name", type: "textInput" },
                            { name: "Last Name", type: "textInput" },
                            { name: "Business Name", type: "textInput" },
                            { name: "Phone Number", type: "textInput" },
                            { name: "Email", type: "textInput" }
                        ]
                    }, {
                        name: "Address",
                        type: "fields",
                        items: [
                            { name: "Address", type: "textInput" },
                            { name: "Suburb", type: "textInput" },
                            { name: "Postcode", type: "textInput" },
                            { name: "State", type: "dropDown", items: ["New South Wales", "Victoria", "Queensland", "Western Australia", "South Australia", "Australian Capital Territory", "Tasmania", "Northern Territory"] }]
                    }],
                    optional: false
                },
                {
                    name: 'Your Custom Order',
                    paragraphs: [{
                        name: "Chasis / Engine",
                        type: "fields",
                        items: [{ name: "Car / Chassis", type: "textInput" },
                        { name: "Engine", type: "textInput" },
                        { name: "Engine Induction", type: "dropDown", items: ["Naturally Aspirated", "Supercharged", "Turbocharged", "Twin Charged", "Nitrous"] },
                        { name: "Fuel Type", type: "dropDown", items: ["Gas", "Diesel", "Hybrid"] }]
                    },
                    {
                        name: "Maximum Limits",
                        type: "fields",
                        items: [{ name: "How much HP are you planning to make", type: "textInput" },
                        { name: "How much Torque are you planning to make", type: "textInput" },
                        { name: "What is the MAX Engine RPM", type: "textInput" }]
                    },
                    {
                        name: "Other",
                        type: "fields",
                        items: [{ name: "What is the car being used for? (Street, Race, etc.)", type: "textInput" },
                        { name: "Who Will be Installing?", type: "dropDown", items: ["Myself", "A Workshop"] }]
                    },
                    ],
                    optional: false
                }
            ],
            about: {
                quotes: ['RVO is number 1', 'RVO specialises in autos', 'Something else...'],
                achievements: [{
                    title: "Unrivalled Excellence",
                    description: "RVO is a leading manufacturer of",
                    image: `${contentHost}/image_gallery/rvo/15.jpg`,
                },
                {
                    title: "Our Clients",
                    description: "We work with a wide array of clients",
                    image: `${contentHost}/image_gallery/rvo/22.jpg`,
                },
                {
                    title: "Our Projects",
                    description: "We've worked on some impressive projects",
                    image: `${contentHost}/image_gallery/rvo/8.jpg`,
                }]
            },

            imageGallery: [{ imgPath: `${contentHost}/image_gallery/rvo/1.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/2.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/3.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/4.jpg`, imgDescription: "Fresh 4L60E" },
            { imgPath: `${contentHost}/image_gallery/rvo/5.jpg`, imgDescription: "Fresh 4L60E" },
            { imgPath: `${contentHost}/image_gallery/rvo/6.jpg`, imgDescription: "RVO Headquarters" },
            { imgPath: `${contentHost}/image_gallery/rvo/7.jpg`, imgDescription: "KChing 427 Stroker" },
            { imgPath: `${contentHost}/image_gallery/rvo/8.jpg`, imgDescription: "KChing Motor" },
            { imgPath: `${contentHost}/image_gallery/rvo/9.jpg`, imgDescription: "Build room" },
            { imgPath: `${contentHost}/image_gallery/rvo/10.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/11.jpg`, imgDescription: "KChing Motor" },
            { imgPath: `${contentHost}/image_gallery/rvo/12.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/13.jpg`, imgDescription: "ZF King" },
            { imgPath: `${contentHost}/image_gallery/rvo/15.jpg`, imgDescription: "KChing Jet 747" },
            { imgPath: `${contentHost}/image_gallery/rvo/16.jpg`, imgDescription: "Trackhawk delivery jet" },
            { imgPath: `${contentHost}/image_gallery/rvo/17.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/18.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/19.jpg`, imgDescription: "Jets" },
            { imgPath: `${contentHost}/image_gallery/rvo/20.jpg`, imgDescription: "Dave tearing shit up" },
            { imgPath: `${contentHost}/image_gallery/rvo/21.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/22.jpg`, imgDescription: "KChing on the brake" },
            { imgPath: `${contentHost}/image_gallery/rvo/23.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/24.jpg`, imgDescription: "KChing" },
            { imgPath: `${contentHost}/image_gallery/rvo/25.jpg`, imgDescription: "RVO King" },
            { imgPath: `${contentHost}/image_gallery/rvo/26.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/27.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/28.jpg`, imgDescription: "RVO David working hard" },
            { imgPath: `${contentHost}/image_gallery/rvo/29.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/30.jpg`, imgDescription: "RVO Business Card" },
            { imgPath: `${contentHost}/image_gallery/rvo/31.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/32.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/33.jpg`, imgDescription: "KCHING" },
            { imgPath: `${contentHost}/image_gallery/rvo/34.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/35.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/36.jpg`, imgDescription: "RVO HQ" },
            { imgPath: `${contentHost}/image_gallery/rvo/37.jpg`, imgDescription: "RVO LED SIGN" },
            { imgPath: `${contentHost}/image_gallery/rvo/38.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/39.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/40.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/41.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/42.jpg`, imgDescription: "Fresh Transmission" },
            { imgPath: `${contentHost}/image_gallery/rvo/43.jpg`, imgDescription: "Zilla Motor" },
            { imgPath: `${contentHost}/image_gallery/rvo/44.jpg`, imgDescription: "KChing Spotted" },
            ],
            mainHeader: {
                title: "Performance Modifications & Transmission Specialist",
                googleReviewsLink: "https://www.google.com/search?q=rvo+automatics&oq=rvo+automatics&gs_lcrp=EgZjaHJvbWUqCwgAEEUYJxg7GIoFMgsIABBFGCcYOxiKBTIHCAEQABiABDIICAIQRRgnGDsyBwgDEAAYgAQyBwgEEAAYgAQyBggFEEUYPDIGCAYQRRg8MgYIBxBFGDzSAQgxODY5ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#",
                storeLocations: [{
                    name: "Dandenong",
                    socials: [{
                        name: "Phone",
                        link: "tel:0397945004",
                    },
                    {
                        name: "Facebook",
                        link: "https://www.facebook.com/RVOAUTOMATICS/",
                    },
                    {
                        name: "TikTok",
                        link: "https://www.tiktok.com/@rvoautomatics",
                    }]
                }]
            },
            theme: {
                primary: {
                    main: "rgb(25, 124, 43)",
                    background: "rgba(134, 42, 61, 0.4)",
                    backgroundLight: "rgba(134, 42, 61, 0.2)",
                    backgroundDark: "rgba(134, 42, 61, 0.8)"
                },
                secondary: {
                    main: "rgb(125, 124, 43)",
                    backgroundDark: "rgba(29, 48, 80, 0.8)",
                    background: "rgba(29, 48, 80, 0.2)",
                    backgroundLight: "rgba(29, 48, 80, 0.1)",
                }
            }
        },
        rampex: {
            name: "Rampex",
            siteImages: {
                logo: `${contentHost}/rampex_logo.png`,
                main: `${contentHost}/rampex_main.jpg`,
                favIcon: `${contentHost}/rampex_logo.png`
            },
            staticPage: true,
            navMenu: [{
                label: 'Contact Us',
                toolbarType: "text",
                clickTarget: "contactus"
            }, {
                label: 'Gallery',
                toolbarType: "text",
                clickTarget: 'gallery'
            },
            {
                label: 'Services',
                toolbarType: "text",
                clickTarget: "services"
            },
            {
                label: 'Shop',
                toolbarType: "text",
                clickTarget: "shop"
            }],
            contactUs: [{
                "branch_name": "Rampex Pty Ltd",
                "branch_address": "Unit 1-2, 11 Kempson Court, Keysborough, Victoria, 3173 Australia",
                "branch_map_link": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6288.182957483356!2d145.18202321244377!3d-37.99832667181292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad6136bb325654f%3A0x700b460ddff8ae43!2sRampex%20Engineering!5e0!3m2!1sen!2sau!4v1732620934354!5m2!1sen!2sau",
                "email": "enquiries@rampexengineering.com.au",
                "phone_number": "+ 61 3 9791 9254",
                "abn": "69 600 564 029",
                "trading_hours:": ["Monday to Friday: 8:30am - 5:30pm", "Saturday & Sunday: Closed"],
                "social_links": [{ "name": "Facebook", "icon": "facebook_icon.png", "link": "https://www.facebook.com/menrayrace/" }, { "name": "Instagram", "icon": "instagram_icon.png", "link": "https://www.instagram.com/menrayrace/" }],
            }],
            services: {
                enquiryEmail: "enquiries@rampexengineering.com.au",
                category: [{
                    name: "Race",
                    items: [{
                        name: "Race Engineering",
                        image: contentHost + "/services/rampex/racing.jpg",
                        description: "Race Engineering is a field that thrives on experience. Our staff has a long history of Race Engineering, from local grass roots racing to Supercars, Sports Cars and even Formula 1, Rampex has been fortunate enough to have had involvement in them all. Whether it be a category requiring specific vehicle tuning or a driver that needs guidance, we are eminently suited to assist your team in any capacity."
                    },
                    {
                        name: "Race Support",
                        image: contentHost + "/services/rampex/engineering.jpg",
                        description: "Rampex has a long and distinguished history offering Race Support to a great range of customers in a wide array of categories. Historically we have managed many projects for clients encompassing work from a specific vehicle build to building entire teams that support clients in all aspects of racing. Whether it be full Team Management, Commercial Representation or simply supplying engineering staff and crew, Rampex are ready to support your team in all aspects of racing."
                    }]
                },
                {
                    name: "Engineering",
                    items: [{
                        name: "General Engineering",
                        image: contentHost + "/services/rampex/manufacturing.jpg",
                        description: "Race car build and preparation is a specialist field, and Rampex pride themselves on producing high quality work for all tasks. This experience has paved the way to producing content for a vast array of tasks outside of motorsport. From the transport industry to civil engineering work, we have met the needs to many clients in modern businesses. We are always keen to expand our horizons and look forward to taking on more tasks outside of our normal scope or work."
                    },
                    {
                        name: "Engineering Design",
                        image: contentHost + "/services/rampex/manufacturing.jpg",
                        description: "A fast race car is a well-designed race car, which is an ethos that Rampex is highly experienced with. Applying what has been learned through years of successful development and applying it to new tasks is one of the things we do best. From simple CAD design work through to extensive research and development programs, we are prepared for anything. Rampex produce their own products to and intentionally high standard which means we can do the same for any client."
                    }]
                },
                {
                    name: "Fabrication",
                    items: [{
                        name: "Fabrication Services",
                        image: contentHost + "/services/rampex/manufacturing.jpg",
                        description: "Fabrication is at the fundamental core of what Rampex does. Our staff are some of the most experienced fabricators and machinists in the industry. Aluminium and steel work is at the core of our output but are happy to quote on any task. No job is too big or too small, and all industries are catered for. Rampex prides itself on quality as the forefront of our work, and every fabrication task is met with the same ideology and high standards."
                    }]
                },
                {
                    name: "Manufacturing",
                    items: [{
                        name: "Manufacturing Services",
                        image: contentHost + "/services/rampex/manufacturing.jpg",
                        description: "Manufacturing is about attention to detail. Producing multiple units from a design is an extension of that process. Repeatability when creating batches of components is standard for our staff and it is this approach that ensures Rampex can make reliable parts for clients. Small batch numbers is often a difficult area for small scale manufacturers, and we pride ourselves on the ability to ‘tool up’ to produce multiple components to tight tolerances."
                    }]
                }]
            },
            shop: {
                enquiryEmail: "enquiries@rampexengineering.com.au",
                category: [{
                    name: "Mark IV Fuel Transfer Rig",
                    items: [{
                        name: "",
                        image: contentHost + "/shop/rampex/fuel_tank.jpg",
                        price: "",
                        description: "<p>Rampex Fuel Transfer Rigs are designed to conduct the process of transferring race fuel from a storage device to or from the race car.</p><p>Fuel is measured by weight with the rig able to function in both manual and automatic modes (metered load delivery). The unit is powered by a large 12 Volt battery and is built to the highest safety standards.</p><p>The unit incorporates two separate pumps for genuine bi-directional flow. Power monitoring, vapour control are also included, as well as on board charging.</p><p>The Mark IV Fuel Transfer Rig is built to a specific standard with testing and associated sign off carried out for each stage of production. However, bespoke design changes are possible based on a case-by-case basis.</p><p>Contact Rampex to discuss your specific needs. Price on Application.</p>"
                    }]
                },
                {
                    name: "Road Cases",
                    items: [{
                        name: "",
                        image: contentHost + "/shop/rampex/fuel_tank.jpg",
                        price: "",
                        description: "<p>Rampex build what we like to call ‘Engineered Road Cases’. We understand that road cases come in many shapes and sizes and are happy to make anything a client may require.</p><p>However, within our normal industry of Motor Sport we have identified a requirement to build specific cases to exacting standards that ensure the safe transport of your equipment.</p><p>From your precious Fender to a job specific one of case to transport highly delicate components, Rampex will make you anything.</p><p>Our CNC machining abilities means the use of aluminium plates instead of standard ply wood is no problem with the majority of our jobs heading out with specifically machined base plates. The incorporation of steel support frames is also something we specialise in.</p><p>Call us to discuss your specific needs.</p>"
                    }]
                },
                {
                    name: "Exhausts Systems",
                    items: [{
                        name: "",
                        image: contentHost + "/shop/rampex/fuel_tank.jpg",
                        price: "",
                        description: "<p>The correct exhaust design leads to increased power from your race engine and Rampex are eminently suited to assisting engine builders and racers alike in getting the most out of their cars.</p><p>We produce bespoke systems for various racing categories racing in Australia but are equally comfortable supporting engine builders in development work. An array of primary pipe designs linked to an adjustable length secondary system for dyno testing is something we excel at.</p><p>We have produced exhaust systems for an extensive range of applications. From cars to boats, simple headers to water cooled jacketed systems, nothing is off the table.</p><p>Call us to discuss your specific needs.</p>"
                    }]
                }]
            },
            about: {
                quotes: ['Rampex has been a valuable partner', 'Rampex ramped us', 'Something else'],
                achievements: [{
                    title: "Unrivalled Excellence",
                    description: "Rampex is a leading manufacturer of",
                    image: contentHost + "/services/rampex/racing.jpg"
                },
                {
                    title: "Our Clients",
                    description: "We work with a wide array of clients",
                    image: contentHost + "/services/rampex/racing.jpg"
                },
                {
                    title: "Our Projects",
                    description: "We've worked on some impressive projects",
                    image: contentHost + "/services/rampex/racing.jpg"
                }]
            },
            imageGallery: [{ imgPath: `${contentHost}/image_gallery/rampex/1.jpg`, imgDescription: "This is a test description" },
            { imgPath: `${contentHost}/image_gallery/rampex/2.jpg`, imgDescription: "This is a test description" },
            { imgPath: `${contentHost}/image_gallery/rampex/3.jpg`, imgDescription: "This is a test description" },
            { imgPath: `${contentHost}/image_gallery/rampex/4.jpg`, imgDescription: "This is a test descrption" },
            { imgPath: `${contentHost}/image_gallery/rampex/5.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/6.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/7.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/8.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/9.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/10.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/11.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/12.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/13.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/14.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/15.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/16.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/17.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/18.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/19.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/20.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/21.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/22.jpg`, imgDescription: "" },
            { imgPath: `${contentHost}/image_gallery/rampex/23.jpg`, imgDescription: "" }
            ],
            mainHeader: {
                title: "Rampex Pty LTD - Engineering Specialists",
                googleReviewsLink: "https://www.google.com/maps/place/Menray+Race+Engineering+Pty+Ltd/@-37.912114,145.4160041,13z/data=!4m6!3m5!1s0x6ad623a07551e9cb:0x3c13d228602aef18!8m2!3d-37.9097777!4d145.358637!16s%2Fg%2F11lm49sk9g?entry=ttu&g_ep=EgoyMDI0MDkxOC4xIKXMDSoASAFQAw%3D%3D",
                storeLocations: [{
                    name: "Keysborough",
                    socials: [{
                        name: "Phone",
                        link: "tel:0416741222",
                    },
                    {
                        name: "Facebook",
                        link: "https://www.facebook.com/menrayrace/",
                    },
                    {
                        name: "Instagram",
                        link: "https://www.instagram.com/menrayrace/",
                    }]
                }]
            },
            theme: {
                mode: 'dark',
                primary: {
                    main: "rgb(226, 39, 36)",
                    background: "rgba(134, 42, 61, 0.4)",
                    backgroundLight: "rgba(134, 42, 61, 0.2)",
                    backgroundDark: "rgba(134, 42, 61, 0.8)"
                },
                secondary: {
                    main: "rgb(48, 46, 43)",
                    backgroundDark: "rgba(29, 48, 80, 0.8)",
                    background: "rgba(29, 48, 80, 0.2)",
                    backgroundLight: "rgba(29, 48, 80, 0.1)",
                },
                appBar: {
                    background: "rgb(48, 46, 43)",
                }
            }
        }
    }

    return platforms[getPlatformIndex()][dataType]
}

export { API_ENDPOINT, fetchPlatformData };